import config from 'Config';
const youtubeRegEx = new RegExp(
  'https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)',
);
const youkuRegEx = new RegExp(
  'https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)',
);

function getYoutubeVideoUrl(url: string): string | null | undefined {
  const urlId = youtubeRegEx.exec(url);
  return urlId ? `https://www.youtube.com/embed/${urlId[1]}` : null;
}

function getYoutubeThumbnail(url: string): string | null | undefined {
  const urlId = youtubeRegEx.exec(url);
  return urlId ? `https://img.youtube.com/vi/${urlId[1]}/sddefault.jpg` : null;
}

function getYoukuVideoUrl(url: string): string | null | undefined {
  const urlId = youkuRegEx.exec(url);
  const clientId = config.get('youku.clientId');
  return urlId ? `https://player.youku.com/embed/${urlId[1]}?client_id=${clientId}` : null;
}

function getVideoUrl(url: string): string | null | undefined {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url: string): string | null | undefined {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url: string): boolean {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}

export { getVideoUrl, getVideoThumbnail, isVideoUrl };
